import { apiRequest, apiPerfix } from "./api"
import { axiosAuthHeaders } from "./index"
import { apiErrorText } from '../utils'

/**
 * 取得列印網址
 * 該網址有效時間為，從呼叫此列印API開始計算 1小時內有效
 */
export const getPrintUrl = async (systemConfig, uuid) => {
  const token = await axiosAuthHeaders()
  // console.debug("systemConfig: ", systemConfig)
  if (!systemConfig.invoice_url) {
    return Promise.reject(apiErrorText('need invoice_url'))
  }
	return apiRequest({
		url: `${systemConfig.invoice_url}/${apiPerfix()}/s2s/prints/${uuid}`,
		method: "POST",
    headers: {
      ...token,
    },
	}).then((res) => {
		return res.data
	}).catch((err) => {
    return Promise.reject(err.response.data)
		// return err.response.data
	})
}